import { getServerOptions } from './getServerOptions';
const SCENE7_IS_VIDEO_RENDITION_PATH = '/is/content/';
export function getScene7VideoRenditionURL(requestedRendition, config) {
    const { scene7File, metaData } = requestedRendition;
    const { height, bitrate } = metaData;
    const serverOptions = getServerOptions(undefined, // forces live domain from config
    config);
    const urlAndPath = `${serverOptions.domain}${SCENE7_IS_VIDEO_RENDITION_PATH}${scene7File}-0x${height}-${bitrate / 1000}k`;
    return urlAndPath;
}
